<div>
  <app-filter-product (searchEvent)="search($event)"></app-filter-product>
</div>

<div>
  @if (searchValue.length) {
    <h6 class="odx-title-6" i18n="@@floorplan.header.searchResults">Suchergebnisse</h6>
  }
  @if (filteredResults.length > 0 || !searchValue.length) {
    <div>
      @for (product of filteredResults; track product) {
        <div>
          <hr />
          <app-fgds-product-search-item
            [product]="product"
            [canAddToFloorplan]="floorplanProductTypes.includes(product.type)"
            (addToFloorplan)="addProductToFloorplan(product)"
            (addToBom)="addProductToBom(product)"
          ></app-fgds-product-search-item>
        </div>
      }
    </div>
  } @else {
    <div class="no-products-container">
      <div class="no-products-message" i18n="@@floorplan.productSearch.noResults">Keine Suchergebnisse</div>
      <button
        odxButton
        i18n="@@floorplan.productSearch.usePlaceholder"
        (click)="$event.stopPropagation(); openSelectPlaceholderMenu()"
      >
        Mit einem Platzhalter weiterarbeiten
      </button>
    </div>
  }
</div>
